export default {
    data() {
        return {
            cupsImages: [],
            selected:  {
                title: {
                    'ca' : 'Selecciona la teva companyia actual',
                    'es' : 'Selecciona tu compañía actual'
                },
                default: 'true',
            },
            companies: [
                {
                    title: {
                        'ca' : 'Selecciona la teva companyia actual',
                        'es' : 'Selecciona tu compañía actual'
                    },
                    default: 'true',
                },
                {
                    title: {
                        'ca' : 'Bonpreu',
                        'es' : 'Bonpreu'
                    },
                    slug: "bonpreu",
                    src_goufone: "",
                    src_myGoufone: "images/cups/bonpreu.jpg",
                },
                {
                    title: {
                        'ca' : 'Endesa',
                        'es' : 'Endesa'
                    },
                    slug: "endesa",
                    src_goufone: "",
                    src_myGoufone: "images/cups/endesa.jpg",
                },
                {
                    title: {
                        'ca' : 'Energia XXI',
                        'es' : 'Energia XXI'
                    },
                    slug: "energiaxxi",
                    src_goufone: "",
                    src_myGoufone: "images/cups/energiaxxi.jpg",
                },
                {
                    title: {
                        'ca' : 'E.Nova',
                        'es' : 'E.Nova'
                    },
                    slug: "enova",
                    src_goufone: "",
                    src_myGoufone: "images/cups/enova.jpg",
                },
                {
                    title: {
                        'ca' : 'Estabanell',
                        'es' : 'Estabanell'
                    },
                    slug: "estabanell",
                    src_goufone: "",
                    src_myGoufone: "images/cups/estabanell.jpg",
                },
                {
                    title: {
                        'ca' : 'Holaluz',
                        'es' : 'Holaluz'
                    },
                    slug: "holaluz",
                    src_goufone: "",
                    src_myGoufone: "images/cups/holaluz.jpg",
                },
                {
                    title: {
                        'ca' : 'Iberdrola',
                        'es' : 'Iberdrola'
                    },
                    slug: "iberdrola",
                    src_goufone: "",
                    src_myGoufone: "images/cups/iberdrola.jpg",
                },
                {
                    title: {
                        'ca' : 'Naturgy',
                        'es' : 'Naturgy'
                    },
                    slug: "naturgy",
                    src_goufone: "",
                    src_myGoufone: "images/cups/naturgy.jpg",
                },
                {
                    title: {
                        'ca' : 'Som Energia',
                        'es' : 'Som Energia'
                    },
                    slug: "somenergia",
                    src_goufone: "",
                    src_myGoufone: "images/cups/somenergia.jpg",
                },
                {
                    title: {
                        'ca' : 'La meva companyia no apareix',
                        'es' : 'Mi compañía no aparece'
                    },
                },
            ],
        };
    },
    methods: {
    },
    mounted(){
        this.cupsImages = JSON.parse(this.$el.dataset.cups)
    }
}
